import { applyMiddleware, createStore, compose } from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import rootReducer from '../redux/reducers';

export default function (initialState = {}) {
  return createStore(rootReducer, initialState, compose(applyMiddleware(thunk, logger)));
}
